export const bank_research_warning = `

Before making a decision about where to bank, please ensure that you do your
own research, starting by visiting the bank's website above. We'd recommend
you look at the banking products they offer, their fees and intrests rates,
and their eligibility requirements. This data is as of September 2025.

`.trim();
